import { createRouter, createWebHistory } from 'vue-router'
import store from "@/store/index";
import Cookies from 'js-cookie'
import { isWeiXin, isMobile } from '../utils/index';


const routes = [{
        path: '/',
        name: 'HomeView',
        meta: {
            title: "首页",
        },
        props: (route) => (route.query),
        component: () =>
            import ('@/views/pc/HomeView.vue')
    },
    {
        path: '/app',
        name: 'AppView',
        meta: {
            title: "首页",
        },
        props: (route) => (route.query),
        component: () =>
            import ('@/views/mob/HomeView.vue')
    },
    {
        path: '/personal',
        name: 'PersonalView',
        meta: {
            title: "个人中心",
        },
        props: (route) => (route.query),
        component: () =>
            import ('@/views/pc/PersonalView.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})
router.beforeEach((to, from, next) => {
    const path = to.path

    document.title = 'Yoni-' + to.meta.title;

    if (isWeiXin() || isMobile()) {
        if (path === '/') {
            next({ path: '/app' })
        } else {
            next()
        }
    } else {
        const token = Cookies.get("yoni_token");
        const user = window.localStorage.getItem("user");
        const wallet = window.localStorage.getItem("wallet");
        if (token) {
            store.commit('VUEX_SET_TOKEN', token);
            store.commit('VUEX_SET_USER', JSON.parse(user));
            store.commit('VUEX_SET_WALLET', JSON.parse(wallet));
        }

        if (path.startsWith('/app')) {
            next({ path: '/' })
        } else {
            next()
        }
    }
})

export default router